import React, { Component } from "react";
import { connect } from "react-redux";
import ToastMessage from "../../components/toast";
import Grid from '../../components/grid';
import Loader from "../../components/loader";
import Axios from 'axios';

class AnnualBillingReport extends Component {
    constructor(props) {
        super(props);
    }
    state = {
        loading: true,
        report: [],
        columnDefs: [
            {
                headerName: "Company Short Name",
                field: "shortName",
                sortable: true,
                resizable: true,
                flex: 1,
                sort: 'asc'
            }, {
                headerName: "Client Name",
                field: "clientName",
                sortable: true,
                resizable: true,
                flex: 1,
            }, {
                headerName: "Month Total",
                field: "monthTotal",
                sortable: true,
                resizable: true,
                flex: 1,
                valueFormatter: params => this.formatAsCurrency(params.value)
            }, {
                headerName: "Projected Total",
                field: "projectedTotal",
                sortable: true,
                resizable: true,
                flex: 1,
                valueFormatter: params => this.formatAsCurrency(params.value)
            },
            {
                headerName: "# of Employees",
                field: "numEmployees",
                sortable: true,
                resizable: true,
                flex: 1
            },
            {
                headerName: "Per Employee Per Month",
                field: "PEPM",
                sortable: true,
                resizable: true,
                flex: 1,
                valueFormatter: params => this.formatAsCurrency(params.value)
            }, {
                headerName: "CSR Account",
                field: "csrAccount",
                sortable: true,
                resizable: true,
                flex: 1
            }
        ]
    };

    formatAsCurrency = (val) => {
        return new Intl.NumberFormat('en-US',
            { style: 'currency', currency: 'USD' })
            .format(val);
    };

    getAnnualBillingReport = async (year) => {
        let billingReport = await Axios.get('api/annual-billing/by-client-all', { params: { year } }).catch(e => e);
        return billingReport?.data || [];
    };

    async componentDidMount() {
        let report = await this.getAnnualBillingReport(new Date().getFullYear() - 1);
        let hasUnmapped = report.pop();
        if (hasUnmapped === true) ToastMessage("Some Billing Services Are Not Mapped", "info");
        this.setState({ loading: false, report });
    };

    render() {
        let { loading, report, columnDefs } = this.state;
        let totals = [...report].pop();
        let reportDisplay = [...report.slice(0, report.length - 1)];
        return (
            <>
                <div className="table-header d-flex align-items-center justify-content-between">
                    <h4 className="heading_h4">Projected Annual Billing</h4>
                    {!loading && totals && <>
                        <h6 className="mla">Annual Projected Total: {this.formatAsCurrency(totals.annualProjectedTotal)}</h6>
                        <h6 className="mla">Last Month Total: {this.formatAsCurrency(totals.lastMonthTotal)}</h6>
                    </>}
                    <button className="mla fs12 primary mini" onClick={this.loadingData} disabled={loading}>
                        {loading ? <span>Loading data </span> : <span>Sync Now</span>}
                    </button>
                </div>
                <div className="shadow_white_box full-box mt-0">
                    <div className="filter-list d-flex align-items-center justify-content-between">
                        <div className="filter-field d-flex">
                        </div>

                    </div>
                    {!loading ? <div className='loading-data'>
                        <Grid
                            rowData={reportDisplay}
                            columnDefs={columnDefs}
                            height='600px'
                        >
                        </Grid>
                    </div> : <div className='loading-data d-flex align-items-center justify-content-center'> <Loader></Loader> </div>}
                </div>
            </>
        );
    }
}

function mapStateToProps({ user }) { return { user } };

export default connect(mapStateToProps)(
    AnnualBillingReport
);
